"use client";

import React from "react";
import { Paintbrush, House, Building2, Layers, Palette } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "New Builds",
  icon: Building2,
  description: "Architectural excellence in high-quality domestic construction, delivering bespoke homes from foundation to finish."
}, {
  title: "Renovations",
  icon: Paintbrush,
  description: "Transforming existing structures with precision craftsmanship and modern industrial luxury aesthetics."
}, {
  title: "Extensions",
  icon: House,
  description: "Seamlessly integrating new living spaces into your property with structural integrity and refined detail."
}, {
  title: "Developments",
  icon: Layers,
  description: "Strategic property development solutions focused on maximizing value through superior building standards."
}, {
  title: "Consultation",
  icon: Palette,
  description: "Technical planning and design guidance to align your architectural vision with structural feasibility."
}, {
  title: "Restoration",
  icon: House,
  description: "Meticulous restoration of heritage properties, preserving character while implementing modern performance."
}];
export default function PaintingServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221456" id="building-your-vision" className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16 md:mb-24">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter text-foreground uppercase">
            Our Expertise
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="group relative flex flex-col items-center text-center rounded-sm border border-border/50 shadow-none bg-transparent p-6 pb-8 transition-all duration-500 hover:bg-muted/10 hover:-translate-y-2.5 after:absolute after:bottom-0 after:left-1/2 after:h-[1px] after:w-0 after:-translate-x-1/2 after:bg-secondary after:transition-all after:duration-500 group-hover:after:w-full">
                <CardHeader className="p-0 flex flex-col items-center gap-6 w-full">
                  <CardTitle className="font-default text-xl md:text-2xl tracking-tight text-secondary uppercase">
                    {service.title}
                  </CardTitle>
                  <Icon className="w-12 h-12 stroke-[1px] text-muted-foreground group-hover:text-secondary transition-colors duration-500" />
                </CardHeader>
                <CardContent className="p-0 mt-6">
                  <p className="font-default text-muted-foreground leading-relaxed max-w-[280px] mx-auto text-sm">
                    {service.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}